var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"scrollButton",staticClass:"to-top-button",on:{"click":_vm.scrollToTop}},[_c('arrow-up-icon',{staticClass:"i-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }